module.exports = __webpack_public_path__ + "static/media/rsm-trash.e8e6ba07.svg";